import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const SearchWrap = style({
    ...csstips.flexRoot,
    ...csstips.center,
    paddingTop: 10,
    paddingBottom: 10,
    background: '#fff'
})

export const SearchPageInputWrap = style({
    position: 'relative',
    width: '100%',
    height: 32,
    marginLeft: 15,
    background: '#f8f8f8',
    borderRadius: 20,
    $nest: {
        '&::before': {
            'content': `""`,
            'backgroundImage': 'url(https://static-1253442168.image.myqcloud.com/picture/8173011_90d6dbdcafd02259dd339ba523319c85.jpg)',
            'position': 'absolute',
            'top': '50%',
            'transform': 'translateY(-50%)',
            '-webkit-transform': 'translateY(-50%)',
            'width': 14,
            'height': 14,
            'left': 10,
            'backgroundSize': 'contain'
        }
    }
})

export const SearchPageInput = style({
    border: 'none',
    outline: 'none',
    width: 'calc(100% - 65px)',
    height: '100%',
    fontSize: 14,
    lineHeight: '18px',
    marginLeft: 33,
    backgroundColor: 'transparent',
    $nest: {
        '&::-webkit-input-placeholder': {
            color: '#a7a7a7'
        }
    }
})

export const searchBtn = style({
    fontSize: 14,
    color: '#fff',
    padding: '0px 18px 0px 18px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    outline: 'none',
    border: 'none',
    height: 32,
    marginLeft: 10,
    marginRight: 15,
    background: '#ff5a31',
    borderRadius: 20,
    $nest: {
        '&:active': {
            background: '#e4431b'
        }
    }
})

const deleteTypeTextAnimation = keyframes({
    '0%': {transform: 'translateY(-50%) translateX(100%)', opacity: 0},
    '100%': {transform: 'translateY(-50%) translateX(0%)', opacity: 1}
})

export const deleteTypeText = style({
    'display': 'block',
    'cursor': 'pointer',
    'position': 'absolute',
    'top': '50%',
    'transform': 'translateY(-50%)',
    '-webkit-transform': 'translateY(-50%)',
    'right': 10,
    'animationDuration': '200ms',
    'animationFillMode': 'forwards',
    'animationIterationCount': 1,
    'animationName': deleteTypeTextAnimation,
    'animationTimingFunction': 'linear',
    '$nest': {
        img: {
            width: 16,
            height: 16
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/SearchInput/SearchInput.style.ts